@if ((siteGroupQuery.selectLoading() | async) === true) {
  <div class="spinner m-auto mt-40 h-32 w-32 border-8"></div>
} @else {
  <div class="mb-24">
    <div class="mb-4 flex justify-end">
      @if ((isEditModeEnabled$ | async) === false) {
        <aux-button
          variant="secondary"
          label="Edit"
          icon="Pencil"
          [onClick]="enableEditMode.bind(this)"
        />
      }

      @if ((isEditModeEnabled$ | async) === true) {
        <aux-button
          variant="secondary"
          label="Cancel"
          icon="X"
          [onClick]="cancelEditMode.bind(this)"
        />
      }

      @if ((isEditModeEnabled$ | async) === true) {
        <aux-button
          variant="success"
          label="Save"
          class="ml-1"
          icon="Check"
          [disabled]="!hasChanges"
          [onClick]="onSaveAll.bind(this)"
        />
      }
    </div>

    <ag-grid-angular
      domLayout="autoHeight"
      class="ag-theme-aux"
      id="patient-protocol-table"
      [gridOptions]="(gridOptions$ | async)!"
      [rowData]="(gridData$ | async)!"
      [enableFillHandle]="(isEditModeEnabled$ | async) === true"
      (gridReady)="onGridReady($event)"
      (rowDragEnd)="onRowDragEnd($event)"
      (cellValueChanged)="cellValueChanged($event)"
      (cellEditingStopped)="cellEditingStopped($event)"
    />

    @if (isEditModeEnabled$ | async) {
      <div class="mt-8">
        <button type="button" class="btn--primary" (click)="onAddSiteGroups()">
          Add Site Group
        </button>
      </div>
    }
  </div>
}
